"use client";

/* eslint-disable default-case */
/* eslint-disable no-promise-executor-return */
import { useCallback, useState } from "react";

import { GeoStatus, ICoordinates } from "@types";

export const useGetGeoLocation = (): {
  currentCoordinates: ICoordinates | null;
  currentMunicipality: string;
  getGeoLocation: () => void;
  getGeoCodedLocation: () => void;
  status: GeoStatus;
} => {
  const [currentCoordinates, setCurrentCoordinates] = useState<ICoordinates | null>(null);
  const [currentMunicipality, setCurrentMunicipality] = useState<string>("");
  const [status, setStatus] = useState<GeoStatus>(GeoStatus.Idle);

  const getNavigatorGeo = (): Promise<any> =>
    new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, (error) => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            setStatus(GeoStatus.Denied);
            break;
          case error.POSITION_UNAVAILABLE:
            setStatus(GeoStatus.Unavailable);
            break;
          case error.TIMEOUT:
            setStatus(GeoStatus.Timeout);
            break;
        }

        return reject(new Error(error as unknown as string));
      }),
    );

  const getGeoLocation = useCallback(async () => {
    setStatus(GeoStatus.Pending);

    const navigatorGeo = await getNavigatorGeo();

    if (navigatorGeo?.coords) {
      const { latitude, longitude } = navigatorGeo.coords;

      setCurrentCoordinates({ latitude, longitude });
      setStatus(GeoStatus.Success);
    } else {
      setStatus(GeoStatus.Unavailable);
    }
  }, []);

  const getGeoCodedLocation = useCallback(async () => {
    setStatus(GeoStatus.Pending);
    const navigatorGeo = await getNavigatorGeo();

    if (navigatorGeo?.coords) {
      const { longitude, latitude } = navigatorGeo.coords;

      setStatus(GeoStatus.Geocoding);
      setCurrentCoordinates({ latitude, longitude });

      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?types=place&access_token=${process.env.NEXT_PUBLIC_MAPBOX_TOKEN}`,
      );
      const json = await response.json();

      if (json) {
        json.features.forEach((feature: any) => {
          if (feature.place_type[0] === "place") {
            setStatus(GeoStatus.Success);
            setCurrentMunicipality(feature.text);
          } else {
            return false;
          }
        });
      }
    }
  }, [setStatus, setCurrentCoordinates]);

  return {
    currentCoordinates,
    currentMunicipality,
    getGeoLocation,
    getGeoCodedLocation,
    status,
  };
};
